module.exports = __webpack_public_path__ + "static/img/8.af90dc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/8.png
// module id = e++f
// module chunks = 0